require('dotenv').config();

const config = {
  bingApiKey: process.env.REACT_APP_BING_API_KEY,
  newRelicApiKey: process.env.REACT_APP_NEW_RELIC_API_KEY,
  corsURL: process.env.REACT_APP_CORS_URL,
}

module.exports = { config: config };